import React from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import constants from '../../constants/constants'
import social from '../../constants/social'
import styles from '../../constants/styles'
import colors from '../../constants/colors'
import OptimizedImage from '../shared/OptimizedImage'

const column1 = [
  { title: 'About', path: 'https://impact.abillion.com/about' },
  { title: 'Careers', path: 'https://impact.abillion.com/careers' },
  { title: 'Press', path: `${constants.webURL}/press` },
  { title: 'Contact', path: `${constants.webURL}/contact` }
]

const column2 = [
  { title: 'Awards', path: 'https://www.awards.abillion.com/' },
  {
    title: 'Business',
    path: 'https://business.abillion.com/?utm_source=footerWeb'
  },
  { title: 'Data', path: 'https://www.data.abillion.com/' }
]

const column3 = [
  {
    title: 'Community Guidelines',
    path: `${constants.webURL}/policies/community`
  },
  {
    title: 'Privacy Policy',
    path: `${constants.webURL}/policies/privacy`
  },
  { title: 'Terms of Use', path: `{constants. webURL}/policies/terms` },
  {
    title: 'Copyright Dispute Policy',
    path: `${constants.webURL}/policies/copyright`
  }
]

const FooterMobile = () => (
  <Container>
    <Section>
      <Link href="/">
        <a style={{ width: '40%' }}>
          <Logo
            size="200"
            src="../../static/abillion-logo-white.png"
            alt="abillion logo"
            title="abillion logo"
          />
        </a>
      </Link>
    </Section>

    <Section>
      <ul>
        {column1.map((p) => (
          <SectionItem key={p.title}>
            <ClaimExternalLink href={p.path} target="_blank">
              <InfoLink>{p.title}</InfoLink>
            </ClaimExternalLink>
          </SectionItem>
        ))}
      </ul>
    </Section>

    <Section>
      <ul>
        {column2.map((p) => (
          <SectionItem key={p.title}>
            <ClaimExternalLink href={p.path} target="_blank">
              {p.title}
            </ClaimExternalLink>
          </SectionItem>
        ))}
      </ul>
    </Section>

    <Section>
      <ul>
        {column3.map((p) => (
          <SectionItem key={p.title}>
            <ClaimExternalLink href={p.path} target="_blank">
              <InfoLink>{p.title}</InfoLink>
            </ClaimExternalLink>
          </SectionItem>
        ))}
      </ul>
    </Section>

    <Section>
      <DownloadActionContainer>
        <AppStoreDiv
          href="https://itunes.apple.com/us/app/abillionveg/id1377119949?mt=8"
          target="_blank"
          rel="noopener noreferrer"
        >
          <AppStoreImage
            size="120"
            src="https://res.cloudinary.com/abillionveg/image/upload/v1526616980/iOSArtboard_18_4x-8_t7me9s.png"
            alt="Available on the App Store"
            title="Available on the App Store"
            loading="lazy"
          />
        </AppStoreDiv>

        <AppStoreDiv
          href="https://play.google.com/store/apps/details?id=com.abvmobile"
          target="_blank"
          rel="noopener noreferrer"
        >
          <AppStoreImage
            size="120"
            src="https://res.cloudinary.com/abillionveg/image/upload/v1526618716/iOSArtboard_14_rb42mw.png"
            alt="Get it on Google Play"
            title="Get it on Google Play"
            loading="lazy"
          />
        </AppStoreDiv>
      </DownloadActionContainer>
    </Section>

    <Section>
      <SocialMedia>
        {social.slice(0, 4).map((s) => (
          <SocLink
            key={s.type}
            href={s.link}
            title={s.title}
            target="_blank"
            rel="noopener noreferrer"
          >
            {s.icon}
          </SocLink>
        ))}
      </SocialMedia>
    </Section>

    <Section>
      <Copyright>{`© abillion ${new Date().getFullYear()}`}</Copyright>
    </Section>
  </Container>
)

export default FooterMobile

const Container = styled.footer`
  width: 100%;
  padding: 32px;
  display: block;
  text-align: center;
  background-color: ${colors.liquorice[100]};
  color: ${styles.colors.white};
  @media (min-width: 900px) {
    display: none;
  }
`

const Logo = styled(OptimizedImage)`
  width: 30%;
  min-width: 160px;
  object-fit: contain;
`

const Section = styled.section`
  text-align: center;
  margin: ${styles.margin.large} 0;
`

const SectionItem = styled.li`
  font-size: 0.8em;
  padding-top: ${styles.padding.medium};
`

const ClaimExternalLink = styled.a`
  text-decoration: none;
  font-size: 1em;
  color: ${styles.colors.white};
  &:hover {
    border-bottom: 2px solid ${styles.colors.white};
  }
`

const InfoLink = styled.span`
  text-decoration: none;
  font-size: 1em;
  color: ${styles.colors.white};
  &:hover {
    border-bottom: 2px solid ${styles.colors.white};
  }
`

const SocialMedia = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
`

const SocLink = styled.a`
  text-decoration: none;
  font-size: 2em;
  color: ${styles.colors.white};
  margin: 0 ${styles.margin.medium};
  display: flex;
  align-items: center;
`

const Copyright = styled.span`
  font-size: 0.8em;
`

const DownloadActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const AppStoreDiv = styled.a`
  width: 160px;
  margin: ${styles.margin.medium} 0;
`

const AppStoreImage = styled(OptimizedImage)`
  max-width: 100%;
  height: auto;
  object-fit: cover;
`
